/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { DiscreteNumericValueDtoGeometry } from './DiscreteNumericValueDtoGeometry';
import {
    DiscreteNumericValueDtoGeometryFromJSON,
    DiscreteNumericValueDtoGeometryFromJSONTyped,
    DiscreteNumericValueDtoGeometryToJSON,
} from './DiscreteNumericValueDtoGeometry';
import type { DiscreteNumericValueDtoEvaluationType } from './DiscreteNumericValueDtoEvaluationType';
import {
    DiscreteNumericValueDtoEvaluationTypeFromJSON,
    DiscreteNumericValueDtoEvaluationTypeFromJSONTyped,
    DiscreteNumericValueDtoEvaluationTypeToJSON,
} from './DiscreteNumericValueDtoEvaluationType';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';
import type { CreateDefinitionParameterDtoValueType } from './CreateDefinitionParameterDtoValueType';
import {
    CreateDefinitionParameterDtoValueTypeFromJSON,
    CreateDefinitionParameterDtoValueTypeFromJSONTyped,
    CreateDefinitionParameterDtoValueTypeToJSON,
} from './CreateDefinitionParameterDtoValueType';

/**
 * 
 * @export
 * @interface DiscreteNumericValueDto
 */
export interface DiscreteNumericValueDto {
    /**
     * 
     * @type {string}
     * @memberof DiscreteNumericValueDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DiscreteNumericValueDto
     */
    dataTypeId?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscreteNumericValueDto
     */
    setupParameterId?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscreteNumericValueDto
     */
    groupId?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscreteNumericValueDto
     */
    name?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DiscreteNumericValueDto
     */
    isRequired?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DiscreteNumericValueDto
     */
    isReadonly?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DiscreteNumericValueDto
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DiscreteNumericValueDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof DiscreteNumericValueDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {number}
     * @memberof DiscreteNumericValueDto
     */
    value?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DiscreteNumericValueDto
     */
    numericId?: string;
    /**
     * 
     * @type {number}
     * @memberof DiscreteNumericValueDto
     */
    defaultValue?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DiscreteNumericValueDto
     */
    unitAbbreviation?: string | null;
    /**
     * 
     * @type {CreateDefinitionParameterDtoValueType}
     * @memberof DiscreteNumericValueDto
     */
    valueType?: CreateDefinitionParameterDtoValueType | null;
    /**
     * 
     * @type {DiscreteNumericValueDtoEvaluationType}
     * @memberof DiscreteNumericValueDto
     */
    evaluationType?: DiscreteNumericValueDtoEvaluationType | null;
    /**
     * 
     * @type {number}
     * @memberof DiscreteNumericValueDto
     */
    decimalPlaces?: number | null;
    /**
     * 
     * @type {DiscreteNumericValueDtoGeometry}
     * @memberof DiscreteNumericValueDto
     */
    geometry?: DiscreteNumericValueDtoGeometry | null;
    /**
     * 
     * @type {string}
     * @memberof DiscreteNumericValueDto
     */
    groupName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DiscreteNumericValueDto
     */
    groupHash?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof DiscreteNumericValueDto
     */
    availableValues?: Array<number> | null;
    /**
     * 
     * @type {string}
     * @memberof DiscreteNumericValueDto
     */
    $type?: DiscreteNumericValueDtoTypeEnum;
}


/**
 * @export
 */
export const DiscreteNumericValueDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoNumericDtoDiscreteNumericValueDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.DiscreteNumericValueDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type DiscreteNumericValueDtoTypeEnum = typeof DiscreteNumericValueDtoTypeEnum[keyof typeof DiscreteNumericValueDtoTypeEnum];



/**
 * Check if a given object implements the DiscreteNumericValueDto interface.
 */
export function instanceOfDiscreteNumericValueDto(value?: unknown): value is DiscreteNumericValueDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(DiscreteNumericValueDtoTypeEnum)[0];
}

export function DiscreteNumericValueDtoFromJSON(json: any): DiscreteNumericValueDto {
    return DiscreteNumericValueDtoFromJSONTyped(json, false);
}

export function DiscreteNumericValueDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiscreteNumericValueDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'dataTypeId': json['dataTypeId'] == null ? undefined : json['dataTypeId'],
        'setupParameterId': json['setupParameterId'] == null ? undefined : json['setupParameterId'],
        'groupId': json['groupId'] == null ? undefined : json['groupId'],
        'name': json['name'] == null ? undefined : json['name'],
        'isRequired': json['isRequired'] == null ? undefined : json['isRequired'],
        'isReadonly': json['isReadonly'] == null ? undefined : json['isReadonly'],
        'isEnabled': json['isEnabled'] == null ? undefined : json['isEnabled'],
        'iuid': json['iuid'] == null ? undefined : json['iuid'],
        'origin': json['origin'] == null ? undefined : EntityOriginFromJSON(json['origin']),
        'value': json['value'] == null ? undefined : json['value'],
        'numericId': json['numericId'] == null ? undefined : json['numericId'],
        'defaultValue': json['defaultValue'] == null ? undefined : json['defaultValue'],
        'unitAbbreviation': json['unitAbbreviation'] == null ? undefined : json['unitAbbreviation'],
        'valueType': json['valueType'] == null ? undefined : CreateDefinitionParameterDtoValueTypeFromJSON(json['valueType']),
        'evaluationType': json['evaluationType'] == null ? undefined : DiscreteNumericValueDtoEvaluationTypeFromJSON(json['evaluationType']),
        'decimalPlaces': json['decimalPlaces'] == null ? undefined : json['decimalPlaces'],
        'geometry': json['geometry'] == null ? undefined : DiscreteNumericValueDtoGeometryFromJSON(json['geometry']),
        'groupName': json['groupName'] == null ? undefined : json['groupName'],
        'groupHash': json['groupHash'] == null ? undefined : json['groupHash'],
        'availableValues': json['availableValues'] == null ? undefined : json['availableValues'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function DiscreteNumericValueDtoToJSON(value?: DiscreteNumericValueDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'dataTypeId': value['dataTypeId'],
        'setupParameterId': value['setupParameterId'],
        'groupId': value['groupId'],
        'name': value['name'],
        'isRequired': value['isRequired'],
        'isReadonly': value['isReadonly'],
        'isEnabled': value['isEnabled'],
        'iuid': value['iuid'],
        'origin': EntityOriginToJSON(value['origin']),
        'value': value['value'],
        'numericId': value['numericId'],
        'defaultValue': value['defaultValue'],
        'unitAbbreviation': value['unitAbbreviation'],
        'valueType': CreateDefinitionParameterDtoValueTypeToJSON(value['valueType']),
        'evaluationType': DiscreteNumericValueDtoEvaluationTypeToJSON(value['evaluationType']),
        'decimalPlaces': value['decimalPlaces'],
        'geometry': DiscreteNumericValueDtoGeometryToJSON(value['geometry']),
        'groupName': value['groupName'],
        'groupHash': value['groupHash'],
        'availableValues': value['availableValues'],
        '$type': value['$type'],
    });
}

